import logo from '@assets/sialogo.png'
import { Link } from 'react-router-dom';
const Footer = () => {

  return (
    <div className="relative w-full h-[15svh] snap-start bg-white p-3 md:p-10 flex flex-col sm:flex-row items-center justify-between">
      <img src={logo} className='w-28 md:w-32 2xl:w-40' />
      <nav className='flex items-center gap-5'>
        <Link to='/contact'>Connect</Link>
        <Link to='/terms'>Terms</Link>
        <Link to='/policy'>Privacy Policy</Link>
      </nav>
    </div>
  )
}

export default Footer;
